/*
 * 1-Minute Maths
 * Copyright © 2021 - 2024 White Rose Maths
 * FakeSplash.web.tsx - dummy for web apps
 */

/**
 * Splash screen management (web version).
 * On web we have no splash screen - the page just loads in. Therefore, this component is just a dummy.
 */
export function FakeSplash() {
  return null;
}
